'use strict';

const sports = {
  ARCHERY: 'Archery',
  BADMINTON: 'Badminton',
  BASKETBALL: 'Basketball',
  BOXING: 'Boxing',
  CROSS_COUNTRY_SKIING: 'CrossCountrySkiing',
  CROSSFIT: 'Crossfit',
  CYCLING: 'Cycling',
  DANCE: 'Dance',
  ELECTRIC_BIKE: 'ElectricBike',
  GOLF: 'Golf',
  HANDBALL: 'Handball',
  HIKING: 'Hiking',
  HOCKEY: 'Hockey',
  HORSE_RIDING: 'HorseRiding',
  INDOOR_CYCLING: 'IndoorCycling',
  KITESURF: 'Kitesurf',
  MARTIAL_ARTS: 'MartialArts',
  MEDITATION: 'Meditation',
  PILATE_GYM: 'PilateGym',
  ROCK_CLIMB: 'RockClimb',
  ROWING: 'Rowing',
  RUGBY: 'Rugby',
  RUNNING: 'Running',
  SAIL_AND_BOARD: 'SailAndBoard',
  SKIING: 'Skiing',
  SOCCER: 'Soccer',
  SQUASH: 'Squash',
  SURF: 'Surf',
  SWIMMING: 'Swimming',
  TABLE_TENNIS: 'TableTennis',
  TENNIS: 'Tennis',
  TREADMILL: 'Treadmill',
  VOLLEYBALL: 'Volleyball',
  WALKING: 'Walking',
  WEIGHT_TRAINING: 'WeightTraining',
  WORKOUT: 'Workout',
  YOGA: 'Yoga',
};

module.exports = sports;
